
{
  "familyId": "TAA-ONT-PARSER",
  "questions": [
    {
      "id": "TAA-ONT-PARSER-001",
      "familyId": "TAA-ONT-PARSER",
      "module": "Taalbegrip",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "zinsontleding",
      "subSkill": "ontl_zinsdelen_toewijzen",
      "questionType": "sentence_parser",
      "question": "Wijs de zinsdelen toe. Klik eerst op een label, dan op het juiste woord.",
      "context": null,
      "data": {
        "sentenceParser": {
          "sentence": "De kat vangt een muis.",
          "words": ["De", "kat", "vangt", "een", "muis"],
          "labels": ["onderwerp", "persoonsvorm", "lijdend voorwerp"],
          "correctAssignments": {
            "1": "onderwerp",
            "2": "persoonsvorm",
            "4": "lijdend voorwerp"
          }
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Zinsdelen vinden",
            "content": "1) Zoek de persoonsvorm: welk woord verandert als je de tijd verandert? → vangt/ving. 2) Wie of wat vangt? → de kat = onderwerp. 3) Wat vangt de kat? → een muis = lijdend voorwerp.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "parser_ow_pv_lv_basis",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "De persoonsvorm is 'vangt' (verandert bij andere tijd: ving). Wie of wat vangt? → 'kat' = onderwerp. Wat vangt de kat? → 'muis' = lijdend voorwerp.",
        "solutionSteps": [
          "Persoonsvorm: 'vangt' (verander de tijd: ving)",
          "Onderwerp: 'kat' (wie of wat vangt?)",
          "Lijdend voorwerp: 'muis' (wat vangt de kat?)"
        ]
      },
      "pedagogy": { "dok": 2 }
    },
    {
      "id": "TAA-ONT-PARSER-002",
      "familyId": "TAA-ONT-PARSER",
      "module": "Taalbegrip",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "zinsontleding",
      "subSkill": "ontl_zinsdelen_toewijzen",
      "questionType": "sentence_parser",
      "question": "Wijs de zinsdelen toe aan de juiste woorden.",
      "context": null,
      "data": {
        "sentenceParser": {
          "sentence": "Mijn broer leest een boek.",
          "words": ["Mijn", "broer", "leest", "een", "boek"],
          "labels": ["onderwerp", "persoonsvorm", "lijdend voorwerp"],
          "correctAssignments": {
            "1": "onderwerp",
            "2": "persoonsvorm",
            "4": "lijdend voorwerp"
          }
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stap voor stap ontleden",
            "content": "Zoek eerst de persoonsvorm (het werkwoord dat verandert): leest → las. Wie of wat leest? → broer = onderwerp. Wat leest hij? → boek = lijdend voorwerp.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "parser_ow_pv_lv_variant",
      "variantIndex": 2,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "'Leest' is de persoonsvorm (verleden tijd: las). Wie of wat leest? → 'broer' = onderwerp. Wat leest hij? → 'boek' = lijdend voorwerp.",
        "solutionSteps": [
          "Persoonsvorm: 'leest' (verleden tijd: las)",
          "Onderwerp: 'broer' (wie of wat leest?)",
          "Lijdend voorwerp: 'boek' (wat leest hij?)"
        ]
      },
      "pedagogy": { "dok": 2 }
    },
    {
      "id": "TAA-ONT-PARSER-003",
      "familyId": "TAA-ONT-PARSER",
      "module": "Taalbegrip",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "zinsontleding",
      "subSkill": "ontl_zinsdelen_toewijzen",
      "questionType": "sentence_parser",
      "question": "Wijs alle zinsdelen toe. Let op: er is ook een bijwoordelijke bepaling.",
      "context": null,
      "data": {
        "sentenceParser": {
          "sentence": "De leerling schrijft snel een opstel.",
          "words": ["De", "leerling", "schrijft", "snel", "een", "opstel"],
          "labels": ["onderwerp", "persoonsvorm", "bijwoordelijke bepaling", "lijdend voorwerp"],
          "correctAssignments": {
            "1": "onderwerp",
            "2": "persoonsvorm",
            "3": "bijwoordelijke bepaling",
            "5": "lijdend voorwerp"
          }
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Bijwoordelijke bepaling",
            "content": "Een bijwoordelijke bepaling geeft extra informatie over het werkwoord: hoe, wanneer, waar of waarom. 'Snel' vertelt hoe de leerling schrijft.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "parser_bwb_toevoegen",
      "variantIndex": 1,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "'Schrijft' is de persoonsvorm. Wie of wat schrijft? → 'leerling' = onderwerp. Wat schrijft hij? → 'opstel' = lijdend voorwerp. Hoe schrijft hij? → 'snel' = bijwoordelijke bepaling.",
        "solutionSteps": [
          "Persoonsvorm: 'schrijft'",
          "Onderwerp: 'leerling' (wie schrijft?)",
          "Lijdend voorwerp: 'opstel' (wat schrijft hij?)",
          "Bijwoordelijke bepaling: 'snel' (hoe schrijft hij?)"
        ]
      },
      "pedagogy": { "dok": 2 }
    },
    {
      "id": "TAA-ONT-PARSER-004",
      "familyId": "TAA-ONT-PARSER",
      "module": "Taalbegrip",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "zinsontleding",
      "subSkill": "ontl_zinsdelen_toewijzen",
      "questionType": "sentence_parser",
      "question": "Wijs de zinsdelen toe. Er zit ook een meewerkend voorwerp in deze zin.",
      "context": null,
      "data": {
        "sentenceParser": {
          "sentence": "De juf geeft de kinderen een compliment.",
          "words": ["De", "juf", "geeft", "de", "kinderen", "een", "compliment"],
          "labels": ["onderwerp", "persoonsvorm", "meewerkend voorwerp", "lijdend voorwerp"],
          "correctAssignments": {
            "1": "onderwerp",
            "2": "persoonsvorm",
            "4": "meewerkend voorwerp",
            "6": "lijdend voorwerp"
          }
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Meewerkend voorwerp",
            "content": "Het meewerkend voorwerp is aan wie of voor wie iets gebeurt. Aan wie geeft de juf een compliment? → de kinderen = meewerkend voorwerp.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "parser_mv_toevoegen",
      "variantIndex": 1,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "'Geeft' is de persoonsvorm. Wie geeft? → 'juf' = onderwerp. Wat geeft ze? → 'compliment' = lijdend voorwerp. Aan wie? → 'kinderen' = meewerkend voorwerp.",
        "solutionSteps": [
          "Persoonsvorm: 'geeft'",
          "Onderwerp: 'juf' (wie geeft?)",
          "Lijdend voorwerp: 'compliment' (wat geeft ze?)",
          "Meewerkend voorwerp: 'kinderen' (aan wie?)"
        ]
      },
      "pedagogy": { "dok": 2 }
    },
    {
      "id": "TAA-ONT-PARSER-005",
      "familyId": "TAA-ONT-PARSER",
      "module": "Taalbegrip",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "zinsontleding",
      "subSkill": "ontl_zinsdelen_toewijzen",
      "questionType": "sentence_parser",
      "question": "Ontleed deze zin. Let op de inversie: het onderwerp staat niet vooraan.",
      "context": null,
      "data": {
        "sentenceParser": {
          "sentence": "Gisteren kocht mijn vader een nieuwe fiets.",
          "words": ["Gisteren", "kocht", "mijn", "vader", "een", "nieuwe", "fiets"],
          "labels": ["bijwoordelijke bepaling", "persoonsvorm", "onderwerp", "lijdend voorwerp"],
          "correctAssignments": {
            "0": "bijwoordelijke bepaling",
            "1": "persoonsvorm",
            "3": "onderwerp",
            "6": "lijdend voorwerp"
          }
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Inversie",
            "content": "Bij inversie staat het onderwerp niet op de eerste plaats. De zin begint met een bijwoordelijke bepaling ('Gisteren'), dan komt de persoonsvorm ('kocht'), en daarna pas het onderwerp ('vader').",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "parser_inversie",
      "variantIndex": 1,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.66,
      "feedback": {
        "explanationText": "Door inversie staat het onderwerp niet vooraan. 'Gisteren' = bijwoordelijke bepaling (wanneer?). 'Kocht' = persoonsvorm. Wie kocht? → 'vader' = onderwerp. Wat kocht hij? → 'fiets' = lijdend voorwerp.",
        "solutionSteps": [
          "Persoonsvorm: 'kocht'",
          "Onderwerp: 'vader' (wie kocht?)",
          "Lijdend voorwerp: 'fiets' (wat kocht hij?)",
          "Bijwoordelijke bepaling: 'Gisteren' (wanneer?)"
        ]
      },
      "pedagogy": { "dok": 2 }
    }
  ]
}
